import React from "react";
//#region types
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { GraphConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { NumberChartPercentageTag, RoundedIcon, useMountedState } from "components/common";
import useChartsWithCache from "components/common/charts/hooks/useChartsWithCache";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import WidgetSkeleton from "components/common/skeletons/widgetSkeleton";
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";

const SalesNumberChart: React.FC = () => {
  const { getChartByFilter } = useChartsWithCache();
  const { getMounted } = useMountedState();
  const [chartData, setChartData] = React.useState<ApiModels.ReportWidget>();

  const chartAPIKey = GraphConstants.ChartKeys.SalesCurrentMonth;

  React.useEffect(() => {
    getChartByFilter(chartAPIKey, {}, chartAPIKey).then((res) => {
      if (getMounted()) {
        setChartData(res);
      }
    });
  }, []);

  const calculatePercentage = (mainAmount: number, currentAmount: number) => {
    const percentage = currentAmount !== 0 ? ((mainAmount - currentAmount) / Math.abs(currentAmount)) * 100 : 0;
    return Number(percentage.toFixed(2));
  };

  return chartData && chartData.data && chartData.data.length > 0 ? (
    <Grid
      key={chartAPIKey}
      container
      className={cssExports.salesNumberChartContainer}
      direction={"column"}
      wrap={"nowrap"}
    >
      {chartData?.data?.map((item, i, data) =>
        i === 0 ? (
          <Grid
            key={item.name}
            item
            container
            direction="row"
            wrap="nowrap"
            alignItems="center"
            className={cssExports.mainRow}
            sx={{ gap: 2 }}
          >
            <Grid item>
              <RoundedIcon icon={IconDefinitionConstants.WMoneyBag} displayType={StyleEnums.DisplayType.Info} />
            </Grid>
            <Grid item xs sx={{ minWidth: 0 }} className={cssExports.mainAmount}>
              {`${LocalizationHelperInstance.getFormattedNumber(item.dataPoints ? item.dataPoints[0] : 0)} kr`}
            </Grid>
          </Grid>
        ) : (
          <Grid
            key={item.name ?? ""}
            item
            container
            direction="row"
            wrap="nowrap"
            alignItems="center"
            className={cssExports.compactRow}
            sx={{ gap: 1 }}
          >
            <Grid item xs className={cssExports.rowDate}>
              {item.name}
            </Grid>
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "12px",
                flexShrink: 0,
                width: "auto",
              }}
            >
              <Grid item>
                <NumberChartPercentageTag
                  percentage={calculatePercentage(
                    data[0].dataPoints ? data[0].dataPoints[0] : 0,
                    item.dataPoints ? item.dataPoints[0] : 0
                  )}
                />
              </Grid>
              <Grid item className={cssExports.rowAmount}>
                {item.dataPoints ? `${LocalizationHelperInstance.getFormattedNumber(item.dataPoints[0])} kr` : `- kr`}
              </Grid>
            </Grid>
          </Grid>
        )
      )}
    </Grid>
  ) : (
    <WidgetSkeleton />
  );
};

export default SalesNumberChart;
